import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box, TextInput, Switch, Group, Button, NumberInput, Select } from '@mantine/core'
import { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import type { IResponse } from "../../types/api";
import type { IContact } from "./types";
import { contactTypes } from "./constants";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";

interface FormValues extends Pick<IContact, 'label' | 'type' | 'text' | 'value' | 'order'> {
}

const EditCategory = () => {

    const { state: id = null } = useLocation();

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            label: '',
            order: 0,
            text: '',
            type: 'text',
            value: ''
        },
        validate: {
            type: isNotEmpty('Төрөл сонгоно уу'),
            label: isNotEmpty('Түлхүүр үг оруулна уу'),
            text: isNotEmpty('Текст оруулна уу'),
            value: isNotEmpty('Утга оруулна уу'),
            order: isNotEmpty('Дараалал оруулна уу'),
        },
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.get<IResponse<IContact>>(`${API_ROUTE}/${id}`);
            form.setValues(data.result);
            form.resetDirty();
        }
        void fetchData();
    }, []);

    const handleSubmit = async (values: typeof form.values) => {
        const { data } = await axios.post<IResponse<any>>(`${API_ROUTE}/${id}`, values);

        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа',);
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE}`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto">
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <Select
                            withAsterisk
                            data={contactTypes}
                            label={'Төрөл'}
                            {...form.getInputProps('type')}
                        />

                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Түлхүүр үг"
                            placeholder="Түлхүүр үг оруулна уу"
                            {...form.getInputProps('label')}
                        />

                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Текст"
                            placeholder="Текст оруулна уу"
                            {...form.getInputProps('text')}
                        />

                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Утга"
                            placeholder="Утга оруулна уу"
                            {...form.getInputProps('value')}
                        />

                        <NumberInput
                            withAsterisk
                            label="Дараалал"
                            placeholder="Дараалал"
                            {...form.getInputProps('order')}
                        />

                        <Switch
                            label="Идэвхтэй эсэх"
                            {...form.getInputProps('isActive', { type: 'checkbox' })}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default EditCategory;